(function () {
    'use strict';

    /**
     * 
     * @ngdoc service
     * @name adminCrewBatchers.service:CrewBatchService
     *
     * @description
     *
     */
    angular
        .module('airport')
        .service('AirportService', AirportService);

    function AirportService(AirportFactory, RemoteService) {
        var self = this;
        
        var offsetTypes = [ {sign:'+'} , {sign:'-'} ];
        
        self.searchAirportMasterData = function( successFn, errorFn){
        	RemoteService.loadAirportList().then(
                  function (response) {
                  	  var formatedList = AirportFactory.formatAirportList(response.airPortListDTOs);
                      successFn(formatedList);
                  },
                  function (error) {
                      errorFn(error.msg[0]);
                  }
              );
        }
        
        self.searchFuelSuppliersMasterData = function(successFn, errorFn){
        	RemoteService.searchFuelSuppliers({}).then(
                    function (response) {
                    	var formatedList = AirportFactory.formatAirportSupplierList(response.fuelSupplierInfoCollection);
                        successFn(formatedList);
                    },
                    function (error) {
                        errorFn(error.msg[0]);
                    }
                );
        }
        
        
        self.searchAirportGridData = function (airportSearchReq, successFn, errorFn){
          var airportSearchReq = AirportFactory.populateAirportSearchRequest(airportSearchReq);
          RemoteService.searchAirports(airportSearchReq).then(
              function (response) {
            	  var airportInfo = AirportFactory.formatAirportInfoSearchResponse(response.airports);
                  successFn(airportInfo,response.startPosition);
              },
              function (error) {
                  errorFn(error.msg[0]);
              }
          );
       }
        
        
        self.searchAirportCategories = function(successFn, errorFn){
        	RemoteService.searchAirportCategories().then(
              function (response) {
                 var airportCats = AirportFactory.formatAirportCategorySearchResponse(response.airportCategories);
                 successFn(airportCats);
              },
              function (error) {
                 errorFn(error.msg[0]);
              }
            );
        }
        
        self.searchLanugages = function(successFn, errorFn){
        	RemoteService.loadLanguageList().then(
                function (response) {
                  var langsList = AirportFactory.formatLanguagesSearchResponse(response.languageList);
                  successFn(langsList);
                },
                function (error) {
                  errorFn(error.msg[0]);
                }
            );
        }
        
        self.getNewAirport = function(){
        	return AirportFactory.getNewAirport();
        }
        
        
        self.formatGridSelectedRow = function(rowData){
        	return AirportFactory.formatGridSelectedRow(rowData);
        }
        
        self.deleteAirportInfo = function(data,successFn, errorFn){
        	var airportDeleteRequest = AirportFactory.populateAirportDeleteRequest(data);
        	RemoteService.deleteAirportInfo(airportDeleteRequest).then(
                    function (response) {
                      successFn(response);
                    },
                    function (error) {
                      errorFn(error.msg[0]);
                    }
            );
        }
        
        self.saveAirport = function(langRequerment,SelectedData,successFn, errorFn){
        	var airportSaveRequest = AirportFactory.populateAirportSaveRequest(SelectedData,langRequerment);
        	RemoteService.saveAirport(airportSaveRequest).then(
                    function (response) {
                      successFn(response);
                    },
                    function (error) {
                      errorFn(error.msg[0]);
                    }
            );
        }
        
        self.searchCountries = function(successFn, errorFn){
        	RemoteService.loadCountryList().then(
                    function (response) {
                       successFn(response.countryCollection);
                    },
                    function (error) {
                       errorFn(error.msg[0]);
                    }
            );
        }
        
        self.searchoffsetTypes = function(){
        	return offsetTypes;
        }
        
    }
})();